module.exports = __webpack_public_path__ + "static/nicolemoudaber_2-5cc02dee4a47c7b593b00ebe77f87bc5.jpg";